import { render } from "./error-404.vue?vue&type=template&id=2a2e1b5d"
import script from "./error-404.vue?vue&type=script&lang=js"
export * from "./error-404.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__